/* eslint-disable import/no-unused-modules */
import { isOauthEnabled } from '../auth/auth';
import { OAUTH_URI } from '../config';

export const BET = 'bet';
export const MBET = 'mbet';
export const VEGAS = 'vegas';
export const MVEGAS = 'mvegas';
export const SKYSPORTS = 'skysports';
export const FANTASYFOOTBALL = 'fantasyfootball';
export const ITV7 = 'itv7';
export const POKER = 'poker';
export const MPOKER = 'mpoker';
export const BINGO = 'bingo';
export const CASINO = 'casino';
export const SPORTINGLIFE = 'sportinglife';
export const EXTRA = 'extra';

const ssoMap = {
    [BET]: 'www.skybet.com',
    [MBET]: 'm.skybet.com',
    [VEGAS]: 'www.skyvegas.com',
    [MVEGAS]: 'm.skyvegas.com',
    [SKYSPORTS]: 'www.skysports.com',
    [FANTASYFOOTBALL]: 'fantasyfootball.skysports.com',
    [ITV7]: 'itv7.itv.com',
    [POKER]: 'www.skypoker.com',
    [MPOKER]: 'm.skypoker.com',
    [BINGO]: 'www.skybingo.com',
    [CASINO]: 'www.skycasino.com',
    [SPORTINGLIFE]: 'www.sportinglife.com',
    [EXTRA]: 'super6extra.skysports.com'
};

const oauthMap = {
    [BET]: '/skybet',
    [MBET]: '/skybet',
    [VEGAS]: '/skyvegas',
    [MVEGAS]: '/skyvegas',
    [SKYSPORTS]: '/skysports',
    [FANTASYFOOTBALL]: '/fantasyfootball',
    [ITV7]: '/itv7',
    [POKER]: '/skypoker',
    [MPOKER]: '/skypoker',
    [BINGO]: '/skybingo',
    [CASINO]: '/skycasino',
    [SPORTINGLIFE]: '/sportinglife',
    [EXTRA]: '/s6extra'
};

export const buildTransferLinkAuto = (
    app,
    path,
    isLoggedIn,
    isV2Customer,
    dcmp,
    affID = null
) => {
    let prefix = '';
    let mappedApp;

    if (isV2Customer) {
        mappedApp = ssoMap[app];
        prefix = 'https://';
    } else {
        const map = isOauthEnabled() ? oauthMap : ssoMap;
        mappedApp = map[app];

        prefix = isOauthEnabled() ? OAUTH_URI : '';
    }

    if (!mappedApp) {
        return null;
    }

    const startURLParameter = path !== null ? `${path}&` : '?';
    const islggdnParameter = `islggdn=${isLoggedIn}`;

    const dcmpParameter = !isV2Customer && dcmp ? `&dcmp=${dcmp}` : '';
    const affiliateID =
        !isV2Customer && affID !== null ? `&AFF_ID=${affID}` : '';

    const finalPath = `${startURLParameter}${islggdnParameter}${affiliateID}${dcmpParameter}`;

    return `${prefix}${mappedApp}${finalPath || ''}`;
};
